import { Box } from "@mui/material";
import React from "react";
import { InputField } from "../v3";

export const AddIncentiveForm = () => {
  return (
    <Box display="flex" gap={2}>
      <InputField required fullWidth />
      <InputField required fullWidth />
      <InputField required fullWidth />
    </Box>
  );
};
